import { PropsWithChildren } from 'react'
import { Button, ButtonProps } from '@chakra-ui/react'
import styled from '@emotion/styled'

import { BaseButtonStyles } from 'components/ui/Buttons/Button/styles'
import theme from 'styles/theme'

export const RentButton = styled.button`
  ${BaseButtonStyles};
  background: ${() => theme.token.var('colors.green.a200')};
  color: ${() => theme.token.var('colors.white')};
`

type Props = PropsWithChildren &
  ButtonProps & {
    type?: 'button' | 'reset' | 'submit' | undefined
    isDisabled?: boolean
  }

export const RentActionButton = ({ type, isDisabled, children, ...boxProps }: Props): JSX.Element => {
  return (
    <Button
      type={type}
      fontSize="sm"
      borderRadius="small"
      background={isDisabled ? 'leid.lysGul' : 'leid.gul'}
      color="black"
      wordWrap="break-word"
      maxWidth="100%"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '54px',
        transition: 'background 0.1s ease-in, color 0.1s ease-in',
        textAlign: 'center',
        fontWeight: 600,
        cursor: 'pointer',
        pointerEvents: isDisabled ? 'none' : 'all',
      }}
      _hover={{
        backgroundColor: isDisabled ? 'leid.lysGulLight' : 'leid.gulLight',
      }}
      _focus={{
        outline: 'none',
        boxShadow: 'none',
      }}
      {...boxProps}
    >
      {children}
    </Button>
  )
}
